import React from 'react';
import './Button.css';

/**
 * Reusable Button component with various styles
 * @param {Object} props - Component props
 * @param {string} props.variant - Button variant ('primary', 'secondary', 'accent', 'neutral')
 * @param {string} props.size - Button size ('small', 'medium', 'large')
 * @param {boolean} props.fullWidth - Whether the button should take full width
 * @param {string} props.className - Additional CSS classes
 * @param {Function} props.onClick - Click handler
 * @param {React.ReactNode} props.children - Button content
 * @param {Object} props.rest - Additional props to pass to the button element
 */
const Button = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  className = '',
  onClick,
  children,
  ...rest
}) => {
  const buttonClasses = [
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    fullWidth ? 'btn-full-width' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
